module.exports = __webpack_public_path__ + "img/11 LANDSCAPE.b36c12e1.png";